import { render, staticRenderFns } from "./dal-headfloat-on-menu.vue?vue&type=template&id=173a0ff4&scoped=true"
import script from "./dal-headfloat-on-menu.vue?vue&type=script&lang=js"
export * from "./dal-headfloat-on-menu.vue?vue&type=script&lang=js"
import style0 from "./dal-headfloat-on-menu.vue?vue&type=style&index=0&id=173a0ff4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173a0ff4",
  null
  
)

export default component.exports